import {
  CommentCard,
  CommentText,
  CommentTitle,
  Section,
  SectionTitle,
} from "./timeReportDetailsPanel.styled";

interface CommentsSectionProps {
  sectionTitle: string;
  workerName: string;
  companyTitle: string;
  placeholderTitle: string;
  userComment: string | null;
  companyComment: string | null;
  noComments: boolean;
}

export const CommentsSection = (props: CommentsSectionProps): JSX.Element => {
  return (
    <Section>
      <SectionTitle>{props.sectionTitle}</SectionTitle>
      {props.userComment && (
        <CommentCard>
          <CommentTitle>{props.workerName}</CommentTitle>
          <CommentText>{props.userComment}</CommentText>
        </CommentCard>
      )}
      {props.companyComment && (
        <CommentCard>
          <CommentTitle>{props.companyTitle}</CommentTitle>
          <CommentText>{props.companyComment}</CommentText>
        </CommentCard>
      )}
      {props.noComments && (
        <CommentCard>
          <CommentTitle>{props.placeholderTitle}</CommentTitle>
        </CommentCard>
      )}
    </Section>
  );
};
